import type { PayloadAction } from '@reduxjs/toolkit';
import { createReducer } from '@reduxjs/toolkit';
import {
  changeConnectionType,
  changeEndDate,
  changeLengthOfWork,
  changePageState,
  changePlatforms,
  changeScanFor,
  changeStartDate,
  changeUsersListFileName,
  cleanImportState,
} from 'actions/import';

import { ErrorObject } from 'types';

type ImportState = {
  pageState: number;
  type: 'livestream' | 'lookback';
  startDate: string;
  endDate: string;
  lengthOfWork: string;
  platforms: string[];
  scanFor: string;
  usersListFileName: string;
  loading: string[];
  error: ErrorObject | null;
};

const defaultState: ImportState = {
  pageState: 1,
  type: 'livestream',
  startDate: '',
  endDate: '',
  lengthOfWork: '',
  platforms: [],
  scanFor: '',
  usersListFileName: '',
  loading: [],
  error: null,
};

type ImportReducer<P = void> = (
  state: ImportState,
  payload: PayloadAction<P>
) => ImportState | void;

const handleChangePageState: ImportReducer<number> = (state, { payload }) => {
  state.pageState = payload;
};

const handleChangeConnectionType: ImportReducer<'livestream' | 'lookback'> = (
  state,
  { payload }
) => {
  state.type = payload;
};

const handleChangeStartDate: ImportReducer<string> = (state, { payload }) => {
  state.startDate = payload;
};

const handleChangeEndDate: ImportReducer<string> = (state, { payload }) => {
  state.endDate = payload;
};

const handleChangeLengthOfWork: ImportReducer<string> = (state, { payload }) => {
  state.lengthOfWork = payload;
};

const handleChangePlatforms: ImportReducer<string[]> = (state, { payload }) => {
  state.platforms = payload;
};

const handleChangeScanFor: ImportReducer<string> = (state, { payload }) => {
  state.scanFor = payload;
};

const handleChangeUsersListFileName: ImportReducer<string> = (state, { payload }) => {
  state.usersListFileName = payload;
};

const handleCleanImportState: ImportReducer = () => defaultState;

const handlers = {
  [changePageState.toString()]: handleChangePageState,
  [changeConnectionType.toString()]: handleChangeConnectionType,
  [changeStartDate.toString()]: handleChangeStartDate,
  [changeEndDate.toString()]: handleChangeEndDate,
  [changeLengthOfWork.toString()]: handleChangeLengthOfWork,
  [changePlatforms.toString()]: handleChangePlatforms,
  [changeScanFor.toString()]: handleChangeScanFor,
  [changeUsersListFileName.toString()]: handleChangeUsersListFileName,

  [cleanImportState.toString()]: handleCleanImportState,
};

const importReducer = createReducer(defaultState, handlers);

export default importReducer;
